export default __webpack_public_path__ + "static/media/themify.eda8b943.ttf";